import { gql } from '@apollo/client';

export const CREATE_JOB_FAMILY_MODEL_FRAGMENT = gql`
  fragment JobFamilyModelFragmentForCreate on JobFamilyModel {
    name
    uid
    status
    referenceId
    summary
    jobFamilyGroup {
      uid
    }
  }
`;

export const PATCH_JOB_FAMILY_MODEL_FRAGMENT = gql`
  fragment JobFamilyModelFragment on JobFamilyModel {
    name
    referenceId
    summary
    jobFamilyGroup {
      uid
    }
  }
`;
